window.orcamentoUtil = {
    obterInformacoesEmailPorIdentificador: function (identificadorOrcamento, callback) {
        global.ajax({
            url: "/Orcamento/ObterInformacoesEnvioEmailCliente",
            type: "post",
            data: {
                identificadorOrcamento: identificadorOrcamento
            },
            success: function (data) {

                if (!data) {
                    return;
                }

                if (callback) {
                    callback(data);
                }

            }
        });
    },

    obterInformacoesEmailPorNumero: function (numero, callback) {
        global.ajax({
            url: "/Orcamento/ObterInformacoesEnvioEmailClientePorNumero",
            type: "post",
            data: {
                numero: numero
            },
            success: function (data) {

                if (!data) {
                    return;
                }

                if (callback) {
                    callback(data);
                }

            }
        });
    }
};